import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	a11yAnnouncementItemHidden: {
		id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden',
		defaultMessage: 'The top level menu item {label} has been hidden and moved to the More menu.',
		description:
			'Announcement for assistive technology users when a top level menu item is hidden in the global side navigation.',
	},
	a11yAnnouncementItemReordered: {
		id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered',
		defaultMessage:
			'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
		description:
			'Announcement for assistive technology users when a top level menu item is reordered in the global side navigation.',
	},
});
